export enum TipoUmTempo {
  giorni = 0,
  ore = 1,
  minuti = 2,
  secondi = 3,
  quantitaOre = 4,
  quantitaMin = 5,
  quantitaSec = 6
}
